
<app-button-close-dialog></app-button-close-dialog>

<h2 mat-dialog-title>
  Acción realizada por:
  <strong>
    {{
      data.accion === AccionesDialog.Agregar
        ? 'Agregar'
        : data.accion === AccionesDialog.Eliminar
        ? 'Eliminar'
        : data.accion === AccionesDialog.Ver
        ? 'Ver'
        : data.accion === AccionesDialog.Modificar
        ? 'Modificar'
        : ''
    }}
  </strong>
</h2>

<br>

<mat-dialog-content *ngIf="data.accion === AccionesDialog.Agregar || data.accion === AccionesDialog.Modificar">
  <ngx-spinner [zIndex]="100" name="spLoadCreate" bdColor="rgba(255,255,255,0.8)" size="default"
    color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>
  <form [formGroup]="plantillaForm">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Título</mat-label>
          <input matInput formControlName="Titulo" aria-label="Título de la plantilla" />
        </mat-form-field>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de Escrito</mat-label>
          <mat-select formControlName="IdTipoEscrito" aria-label="Selecciona el tipo de escrito">
            <mat-option *ngFor="let tipo of tiposEscrito" [value]="tipo.id">
              {{ tipo.descripcion }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-6 col-md-12 col-sm-12 ">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descripción</mat-label>
          <textarea matInput formControlName="Descripcion"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <editor apiKey="wpinnleoodbsti594dnh77z0lkrt3ziue0dykmga9m5ik0jt" [init]="init" formControlName="CuerpoHTML">
        </editor>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-content *ngIf="data.accion.Eliminar">
<p>¿Esta seguro que decea eliminar este registro?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add [disabled]="!plantillaForm.valid" (click)="onCrear()"
  *ngIf="data.accion === AccionesDialog.Agregar"></app-button-add>

  <app-button-save [disabled]="!form.valid" (click)="onGuardar()" *ngIf="data.accion === AccionesDialog.Modificar" ></app-button-save>

  <app-button-delete-and-cancel (deleteClicked)="onEliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion === AccionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete-and-cancel>


  <app-button-close *ngIf="data.accion === AccionesDialog.Ver"></app-button-close>
</mat-dialog-actions>


